import React, { useState } from 'react'

import { Header, Button, Grid } from 'semantic-ui-react'

import ExternalLink from '../../components/common/ExternalLink'

const VloggApi = () => {
  const [showForm, setShowForm] = useState(false)

  return (
    <>
      <Header as="h3">
        Vloggi API
        <Header.Subheader>
          Connect your existing business tools with Vloggi via our RESTful API.
        </Header.Subheader>
      </Header>

      <Grid columns={1} verticalAlign="middle" stackable>
        <Grid.Column>
          <Button primary onClick={() => setShowForm(!showForm)}>
            Request Access
          </Button>
        </Grid.Column>

        <Grid.Column style={{ display: showForm ? 'block' : 'none' }}>
          <iframe src="https://vloggi.activehosted.com/f/52" width="100%" height="400" style={{ border: '1px solid #eeeeee', borderRadius: '10px' }}></iframe>
        </Grid.Column>

        <Grid.Column>
          <ExternalLink url="https://vloggi.com/docs/accessing-the-public-vloggi-api-for-advanced-users/">Read more</ExternalLink>
        </Grid.Column>
      </Grid>
    </>
  )
}

export default VloggApi
